import React, { memo } from 'react'

type FlexType = {
  flex?: string
  children?: React.ReactNode
}

export const Flex: React.FC<FlexType> = memo(({ children, flex }) => {
  return <div className={`${flex}`}>{children}</div>
})
Flex.displayName = 'Flex'
